import React from "react"
import PropTypes from "prop-types"
import { Field } from "redux-form/immutable"

import GridToggleSelectField from "app/static/frontend/forms/components/GridToggleSelectField"
import SearchifySelectField from "app/static/frontend/forms/containers/SearchifySelectField"
import { IssueManagementSelect } from "app/static/frontend/selects/containers/PieSelect"

import { BULK_ACTIONS_FORM_KEY } from "shared/imports/sharedConstants"
import { constants } from "shared/forms/BulkActions/constants"

// generic component
export const BulkActionsIssue = (props) => (
    <div className="bulk-actions-console-issues-form" data-cy="bulk-actions-console-issues-form">
        <Field
            allowNull={false}
            choices={DjangIO.app.search.bulkactions.types.IssueSelectType.items().sort(DjangIO.valueSort)}
            className="bulk-actions-form-issue-select"
            component={GridToggleSelectField}
            dropUp={false}
            multi={false}
            name="issue_type"
        />
        {props.issueType > 0 &&
            props.issueType !== DjangIO.app.search.bulkactions.types.IssueSelectType.clear.value && (
                <Field
                    key="issues"
                    // the name/key that will be stored in the reduxForm Immutable map
                    name="issues"
                    // the tooltip hover text that will be displayed to the right of the label
                    tooltipText="Choose the issue(s) to add to."
                    className="bulk-actions-form-issues"
                    component={SearchifySelectField}
                    selectComponent={IssueManagementSelect}
                    props={{
                        // change is inherited from the reduxForm() wrapper in
                        // app/static/frontend/search-new/containers/BulkActions/BulkActionsConsole
                        change: props.change,
                        formKey: BULK_ACTIONS_FORM_KEY,
                        model: DjangIO.app.userdata.models.IssueManagement,
                        name: "issues",
                    }}
                    customProps={constants.CUSTOM_SEARCHIFY_FORM_PROPS_MULTI}
                />
            )}
    </div>
)
BulkActionsIssue.propTypes = {
    // from app/static/frontend/search-new/components/BulkActions/BulkActionsConsole
    change: PropTypes.func.isRequired,
    // from app/static/frontend/search-new/containers/BulkActions/actions/BulkActionsIssue
    issueType: PropTypes.number,
}

export default BulkActionsIssue
